import React, { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { get, size } from "lodash";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Stack,
  Divider,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import { useSnackbar } from "notistack";

import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import Iconify from "../../components/iconify/iconify";
import { Box } from "@mui/system";
import { useAreaForm } from "../../data/talons/Area/useAreaForm";
import { color } from "../../utils/constant";
import { useSelector } from "react-redux";
import { getAreaData } from "../../data/selectors/Area/areaform.selector";
import { useLeaveForm } from "../../data/talons/Leave/useLeaveForm";
import { getLeaveData } from "../../data/selectors/Leave/leaveForm.selector";
/*
 * Render Real - Estate Inquiry Form screen
 *
 *
 */
export default function LeaveForm(props) {
  const { enqueueSnackbar } = useSnackbar();
  const editItem = useSelector(getLeaveData);
  const {
    loader,
    loading,
    status,
    LeaveEntrySchema,
    handleStatusComboChange,
    LeaveEntry,
    LeaveUpdate,
  } = useLeaveForm({
    existingStatus: get(editItem, "status", 0),
  });

  const defaultValues = useMemo(() => ({
    leave_type: get(editItem, "leave_type", ""),
  }));

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
  } = useForm({
    resolver: joiResolver(LeaveEntrySchema),
    defaultValues,
  });

  const onlyNumbers = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");

    if (e.target.value.toString().length === 0) return;
    return (e.target.value = Math.max(0, parseInt(e.target.value))
      .toString()
      .slice(0, 10));
  };

  const onUserSubmit = useCallback(async () => {
    try {
      const res =
        get(editItem, "id", null) === null
          ? await LeaveEntry({
              ...getValues(),
            })
          : await LeaveUpdate({
              ...getValues(),
              id: get(editItem, "id", null),
            });
      if (res === true) {
        props.postSubmit();
      } else {
        enqueueSnackbar("Problem While Saving Leave Data", {
          variant: "error",
        });
      }
    } catch (err) {
      console.log("errr", err);
    }
  }, [LeaveEntry, LeaveUpdate]);

  const onlyCharacters = (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z ]*$/, "");

    return e.target.value;
  };

  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        Leave Form
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item sm={12} xs={12}>
          <TextField
            required
            id="leave_type"
            name="leave_type"
            label="Leave Type"
            onInput={(e) => onlyCharacters(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("leave_type")}
            autoComplete="false"
            error={size(errors?.leave_type?.message) > 0 ? true : false}
            helperText={
              size(errors?.leave_type?.message) > 0
                ? errors?.leave_type?.message
                : ""
            }
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <Typography>
            <FormControlLabel
              sx={{ mt: -1 }}
              control={
                <Checkbox
                  sx={{
                    "&.Mui-checked": {
                      color: color.button,
                    },
                  }}
                  id="is_labour"
                  checked={status}
                  onChange={handleStatusComboChange}
                />
              }
              label="Active"
            />
          </Typography>
        </Grid>
        <Grid container direction="row">
          <Grid item xs={12} sm={12}>
            <Stack direction="row" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  backgroundColor: color.button,
                  "&:hover": {
                    backgroundColor: color.button,
                  },
                }}
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(onUserSubmit)();
                }}
              >
                Save
              </Button>
              <Button
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  borderColor: color.button,
                  color: color.button,
                  "&:hover": {
                    color: color.button,
                  },
                }}
                variant="outlined"
                onClick={(e) => {
                  e.preventDefault();
                  props.postSubmit();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
